import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import Link from 'flarum/common/components/Link';
import highlight from 'flarum/common/helpers/highlight';
import listItems from 'flarum/common/helpers/listItems';

// Matches champis.net's own plain-text discussion rows: date, icon+title
// and "par <author>" all on one line - previously the title sat alone on
// its own line, with a separate "Créé par X il y a Y" line below it (see
// core's TerminalPost, no longer used here at all). No avatar either
// (dropped via CSS, not here - see .DiscussionListItem-author in
// forum.less), and no category tag pill (flarum-tags' own addition to
// infoItems, redundant now that categories live in the header's "Forums"
// menu - see addForumsMenu.js). Species labels (champis-species' own
// infoItems addition) still show below the row, same as before.
export default function simplifyDiscussionListItem() {
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    items.remove('tags');
    items.remove('terminalPost');
  });
  override(DiscussionListItem.prototype, 'mainView', function () {
    const discussion = this.attrs.discussion;
    const jumpTo = this.getJumpTo();

    // Same first-post-vs-last-post logic core's own TerminalPost used -
    // whichever is relevant to the active sort (e.g. "newest" shows who
    // started it, the default "recently active" shows the latest reply).
    // Except in a list of one species' topics - a species page (or a
    // genus', a family's…, see champis-species' SpeciesPage), the homepage
    // filtered by species (DiscussionFilters): there, who presented the
    // species and when, whatever the sort - not whoever happened to reply
    // last (Jplm, 2026-10-18).
    const filter = this.attrs.params.filter;
    const speciesList = !!(filter?.species || filter?.taxon);
    const lastPost = !speciesList && !this.showFirstPost() && discussion.replyCount();
    const user = discussion[lastPost ? 'lastPostedUser' : 'user']();
    const time = discussion[lastPost ? 'lastPostedAt' : 'createdAt']();
    return m(Link, {
      href: app.route.discussion(discussion, jumpTo),
      className: "DiscussionListItem-main"
    }, m("div", {
      className: "ChampisDiscussionRow-header"
    }, m("small", {
      className: "ChampisDiscussionRow-time"
    }, time ? formatCompactTime(time) : ''), m("strong", {
      className: "ChampisDiscussionRow-title"
    }, m("i", {
      className: "icon fas fa-comments",
      "aria-hidden": "true"
    }), " ", m("span", null, highlight(discussion.title(), this.highlightRegExp))), m("small", {
      className: "ChampisDiscussionRow-author"
    }, ' ', app.translator.trans('champis-forum.forum.index.by_text', {
      username: user && user.displayName()
    }))), m("ul", {
      className: "DiscussionListItem-info"
    }, listItems(this.infoItems().toArray())));
  });
}
function formatCompactTime(date) {
  const pad = n => String(n).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${pad(date.getFullYear() % 100)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}